// import appInfo from '@/app-info'
// import axios from 'axios'
// import router from '@/router';

const emptyData = {
  ScreenName: '',
  ChartName: '',
  TagAvailable: '',
  ChartType: '',
  ThresholdMax: 0,
  ThresholdMin: 0,
  IsTrendline: false,
  ListCustomerName: []
}

const validationRules = {
  ScreenName: [
    {
      required: true,
      message: 'Screen Name',
      trigger: 'blur'
    }
  ],
  ChartName: [
    {
      required: true,
      message: 'Chart Name is required',
      trigger: 'blur'
    }
  ],
  TagAvailable: [
    {
      required: true,
      message: 'Tag is required',
      trigger: 'change'
    }
  ],
  ChartType: [
    {
      required: true,
      message: 'Chart Type is required',
      trigger: 'change'
    }
  ],
  ThresholdMax: [],
  ThresholdMin: [],
  IsTrendline: [],
  ListCustomerName: []
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  }
}
